import {useDispatch, useSelector} from 'react-redux';
import {IStore} from 'redux/interface';
import {loadMediaAction} from 'redux/media/mediaAsyncActions';
import {IMediaInitialState} from 'redux/media/interfaces';
import {deleteMediaApi, getMediaUrlApi, getSignedVideoUrlApi} from '../../redux/api/media';
import {ImageSize, IVideoUrl} from '@wholesalechange/chatcomponent';

interface IUseLoadFile {
  media: IMediaInitialState
  getFileUrl: (fileId: number, callback?: (url: string | null) => void) => string
  getFileUrlAsync: (fileId: number, imageSize?: ImageSize) => Promise<string>
  getVideoUrlAsync: (key: string) => Promise<IVideoUrl | null>
  removeFileAsync: (fileId: number) => Promise<boolean>
}

export function useLoadFile(): IUseLoadFile {
  const media = useSelector((store: IStore) => store.media);
  const {
    loading
  } = useSelector((store: IStore) => store.status);
  const dispatch = useDispatch();

  function getFileUrl(fileId: number, callback?: (url: string | null) => void): string {
    if (media[fileId]) {
      if (callback) {
        callback(media[fileId]);
      }

      return media[fileId];
    }
    dispatch(loadMediaAction(fileId, callback));

    return '';
  }

  async function getFileUrlAsync(fileId: number, imageSize?: ImageSize): Promise<string> {
    if (media[fileId]) {
      return media[fileId];
    }

    try {
      const {data: {value: fileUrl} } = await getMediaUrlApi(fileId, imageSize && imageSize === ImageSize.Original);

      return fileUrl;
    } catch (e) {
      console.log('getFileUrlAsync', e);
    }

    return '';
  }

  async function getVideoUrlAsync(key: string): Promise<IVideoUrl | null> {
    try {
      const {data: videoUrl} = await getSignedVideoUrlApi(key);

      return videoUrl;
    } catch (e) {
      console.log('getFileUrlAsync', e);
    }

    return null;
  }

  async function removeFileAsync(fileId: number): Promise<boolean> {
    const {data: {value: result} } = await deleteMediaApi(fileId);

    return result;
  }

  return {
    getFileUrl,
    getFileUrlAsync,
    removeFileAsync,
    getVideoUrlAsync,
    media
  };
}
